import React, { useState } from "react";
import { FileIndex } from "../types";
import { Dropdown } from "react-bootstrap";
import { RenameModal, ConfirmDeleteModal, AssignParentModal } from ".";

const EditButton: React.FC<{
  selectedItem: FileIndex | undefined;
  fileList: FileIndex[];
  refreshFileList: () => Promise<void>;
}> = ({ selectedItem, fileList, refreshFileList }) => {
  const [showRenameModal, setShowRenameModal] = useState<boolean>(false);
  const [showAssignModal, setShowAssignModal] = useState<boolean>(false);
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  return (
    <>
      <RenameModal
        showModal={showRenameModal}
        setShowModal={setShowRenameModal}
        currentDisplayName={selectedItem?.displayName as string}
        currentFileName={selectedItem?.fileName as string}
        refreshFileList={refreshFileList}
      />
      <AssignParentModal
        showModal={showAssignModal}
        setShowModal={setShowAssignModal}
        selectedItem={selectedItem}
        fileList={fileList}
        refreshFileList={refreshFileList}
      />

      <ConfirmDeleteModal
        showModal={showDeleteModal}
        setShowModal={setShowDeleteModal}
        currentFileName={selectedItem?.fileName as string}
        refreshFileList={refreshFileList}
      />
      <Dropdown>
        <Dropdown.Toggle>Edit</Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item onClick={() => setShowRenameModal(true)}>
            Rename
          </Dropdown.Item>
          <Dropdown.Item onClick={() => setShowAssignModal(true)}>
            Move to Folder
          </Dropdown.Item>
          <Dropdown.Item onClick={() => setShowDeleteModal(true)}>
            Delete
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

export default EditButton;
